import { cn } from '@tripleten/cn';

export const cnMagicLinkForm = cn('magic-link-form');
